import { Table } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import ReconsLandingPage from "./pages/ReconsLandingPage";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import { FEATURE_ODP } from "../../utils/UserAccessControlUtils";

const ReconsRouter: NavigationLinkProps[] = [
  {
    id: "bc5883cc-e1e2-4d62-aaa5-0c88e3bf0501",
    title: "Recons",
    description: "",
    path: "/recons",
    auth: true,
    sidebar: true,
    icon: Table,
    component: ReconsLandingPage,
    requiredFeature: FEATURE_ODP,
    requiredFeatureFlag:
      FeatureFlags.EMPLOYER_PORTAL_AUTOMATED_ODP_INVOICING_VIEW,
    isFeatureFlagged: true,
    requiredPermissions: ["ANY"],
  },
];

export default ReconsRouter;
